var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "172.457143px",
    height: "114.2px",
    viewBox: "0 0 172.457143 114.2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "airtag-radiowaves-forward-fill (1)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "airtag-radiowaves-forward-fill-(1)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.0642855,114.2 C88.2071428,114.2 114.135714,88.2714285 114.135714,57.1285715 C114.135714,25.9857145 88.1357143,0 57,0 C25.8571428,0 0,25.9928572 0,57.1285715 C0,88.2714287 25.9285715,114.2 57.0714285,114.2 L57.0642855,114.2 Z M147.528571,100.007143 C149.728571,102.65 153.557143,102.707143 156.385714,99.6928572 C166.742857,88.5857145 172.457143,73.457143 172.457143,57.1285715 C172.457143,40.807143 166.614286,25.557143 156.385714,14.5642857 C153.621429,11.4928572 149.785714,11.6142857 147.528571,14.25 C145.392857,16.7 146.085714,19.8428572 148.471429,22.5357143 C156.692857,31.642857 161.214286,43.7571428 161.214286,57.1285715 C161.214286,70.4428572 156.628571,82.6214287 148.471429,91.7214285 C146.085714,94.4214285 145.4,97.5571428 147.528571,100.007143 Z M129.257143,82.0571428 C131.457143,84.6285713 135.6,84.7571428 138.114286,81.6142857 C143.514286,75.15 146.585714,66.4214285 146.585714,57.1285715 C146.585714,47.8428572 143.514286,39.1142857 138.114286,32.5857143 C135.6,29.5142857 131.457143,29.5714285 129.257143,32.2071428 C127.185714,34.6571428 128.007143,37.6714285 130.014286,40.4928572 C133.464286,44.8857145 135.35,50.9214287 135.35,57.1357143 C135.35,63.35 133.464286,69.3714285 130.014286,73.7642857 C128.007143,76.5928572 127.185714,79.607143 129.257143,82.05 L129.257143,82.0571428 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.37dc71a0f5ad9d2db32c61208d561109.svg";
export { ForwardRef as ReactComponent };